import {
  Button,
  DialogActions,
  DialogContent,
  Typography,
  Zoom,
} from "@material-ui/core";
import { IconCircleCheck } from "@tabler/icons-react";

interface props {
  successMessage?: string;
  handleClose: () => void;
}

const SuccessDialogBody = ({ successMessage, handleClose }: props) => {
  return (
    <>
      <DialogContent
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Zoom in={true} mountOnEnter unmountOnExit>
          <IconCircleCheck size={120} color="#50C878" strokeWidth={1} />
        </Zoom>
        <Typography
          style={{ textAlign: "center", fontSize: "20pt", fontWeight: "600" }}
        >
          Éxito
        </Typography>
        <Typography
          variant="subtitle1"
          color="textSecondary"
          style={{ textAlign: "center" }}
        >
          {successMessage}
        </Typography>
      </DialogContent>

      <DialogActions style={{ padding: "20px" }}>
        <Button
          fullWidth
          onClick={handleClose}
          variant="contained"
          color="default"
          size="large"
        >
          Aceptar
        </Button>
      </DialogActions>
    </>
  );
};

export default SuccessDialogBody;
